/**
 * ShopInformationList
 * --
 */
import React, { useState, useEffect } from 'react';
import { Content, TabMenu } from 'components';
import { ShopInformationApi } from 'api';
import MessageAlert, { isNull } from 'utils';
import { stringToMoneyFormat } from 'utils';
import { Input } from 'antd';
import moment from 'moment';

import {
  PAYMENT_METHOD_CONSTANT, // 주문 유형
  PAYMENT_STATUS_CONSTANT, // 주문의 결제상태
  PRODUCT_TYPE, // 상품유형
  PACKAGING_METHOD, // 포장방식
  // PRODUCT_STATUS, //상품 판매 상태
  // APPLICATION_STATUS, // 상품 등록 승인여부
  // TAX_TYPE, // 과세유형
} from 'constants/ProductConstants';

/**----------------------------------------
 * [Component] 입점업체 목록: 사이드 컴포넌트
 * ----------------------------------------
 */
const ShopInformationList = ({ onChange, query, onLoaded }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  // 선택된 업체의 키
  const [keyword, setKeyword] = useState('');
  // 선택된 업체의 키
  const [currentShop, setCurrentShop] = useState(null);
  // 업체목록
  const [shopList, setShopList] = useState([]);

  /* ===== VARIABLE ===== */
  const filteredData = shopList
    ?.filter((item) => item.shop_information_name.indexOf(keyword) >= 0)
    .map((item) => {
      const information =
        item.type === 'STORE' ? item.store_information : item.mall_information;

      return {
        ...item,
        information,
      };
    });
  /* ===== FUNCTION ===== */
  /**--------------------
   * 업체목록 조회
   * --------------------
   */
  const getShopInformations = async () => {
    try {
      const { status, message, data } =
        await ShopInformationApi.getShopInformations(query);
      if (status !== 200) throw { message };

      if (!query) {
        setShopList(
          data.filter((item) => item.type === 'ALL' || item.type === 'SHOP')
        );
      } else {
        setShopList(data);
      }
      // data.filter((item) => item.type === 'ALL' || item.type === 'SHOP')
      // data.filter((item) => item.type === 'ALL' || item.is_brand === 'Y')
    } catch (e) {
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    getShopInformations();
  }, []);
  useEffect(() => {
    onChange(currentShop);
  }, [currentShop]);
  useEffect(() => {
    onLoaded(shopList);
  }, [shopList]);
  useEffect(() => {
    onLoaded(filteredData);
  }, [keyword]);

  /* ===== RENDER ===== */
  return (
    <>
      <Content
        maxWidth={'100%'}
        height={'100%'}
        minHeight={490}
        padding={0}
        className="boxShadow"
        backgroundColor="#fff"
      >
        {/* === === */}
        <Content
          maxWidth={'100%'}
          padding={10}
          style={{ borderBottom: '1px solid #EBEBEB' }}
        >
          <Input
            placeholder="업체명을 입력해주세요"
            allowClear
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </Content>

        {/* === === */}
        <Content maxWidth={'100%'} padding={5}>
          <TabMenu
            items={filteredData?.map((item) => ({
              ...item,
              key: item.shop_information_id,
              activeKey: item.shop_information_id,
              // title: item.shop_information_name,
              label: (
                <>
                  <p
                    className="cursorOverOpacity"
                    style={{ fontSize: '0.9em' }}
                  >
                    {item.shop_information_name}
                    <br />
                    <span
                      style={{
                        fontWeight: '400',
                        color: '#9a9a9a',
                        fontSize: '0.9em',
                      }}
                    >
                      {item?.information?.business_num ?? ''}{' '}
                      {item?.information?.store_owner
                        ? `(${item?.information?.store_owner})`
                        : ''}
                    </span>
                  </p>
                </>
              ),
            }))}
            activeKey={'shop_information_id'}
            collapseKey={'shop_information_id'}
            onChange={({ key }) => setCurrentShop(key)}
          />
        </Content>
      </Content>
    </>
  );
};

ShopInformationList.defaultProps = {
  defaultId: null,
  query: null,
  onChange: () => {},
  onLoaded: () => {},
};
export default ShopInformationList;
